import type { ChatStatus } from "ai";

export type SubmitMode = "send" | "stop";

/**
 * What the composer's single submit control should do right now.
 *
 * While a turn is in flight the control doubles as a **Stop** button — but
 * only while the composer is empty. The moment the user has something to send
 * (typed text *or* a staged attachment), it flips back to a send arrow so they
 * can *queue* that message mid-turn (the chat surface holds it and sends it
 * once the agent goes idle). So: busy + empty → "stop"; everything else →
 * "send". `hasContent` must mirror the submit guard (text or files), or an
 * attachment-only follow-up would be trapped behind a Stop button.
 *
 * Pure (no React) so it lives apart from `Composer.tsx` and can be unit-tested
 * without dragging in the DOM-aliased component graph.
 */
export function submitMode(
  status: ChatStatus,
  hasContent: boolean,
): SubmitMode {
  const busy = status === "submitted" || status === "streaming";
  return busy && !hasContent ? "stop" : "send";
}
